import mapboxgl from 'mapbox-gl';

/**
 * Custom Map Control with a getContainer method which
 * returns a reference to dom layer used by the Map instance
 * for map control placement.
 * Provides a a sneaky hook for rendering a react component
 * into the map control layer.
 * @example
 *  const mapControlLayer = new MapControlTrojan().getContainer();
 *  ReactDOM.render(reactComponent, mapControlLayer)
 */
class MapControlTrojan implements mapboxgl.IControl {
  private _map: mapboxgl.Map | undefined;
  private _container: HTMLElement;

  public constructor() {
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl react-ctrl-wrapper';
  }

  public getContainer() {
    return this._container;
  }

  /**
   * Used by the mapboxgl addControl() method. Don't call this directly.
   * @param map instance of mapboxgl Map
   * @returns html element containing a rendered React component
   * @see https://docs.mapbox.com/mapbox-gl-js/api/markers/#icontrol#onadd
   */
  public onAdd(map: mapboxgl.Map): HTMLElement {
    // Render the React element into a generic div which can then be
    // passed along to the Map instance
    this._map = map;
    // ReactDOM.render(this._wrapped, this._container);
    return this._container;
  }

  /**
   * Used by the mapboxgl addControl() method. Don't call this directly.
   * @see https://docs.mapbox.com/mapbox-gl-js/api/markers/#icontrol#onadd
   */
  public onRemove() {
    if (this._container && this._container.parentNode)
      this._container.parentNode.removeChild(this._container);
    if (this._map) this._map = undefined;
  }
}

export { MapControlTrojan };
